module.exports = __webpack_public_path__ + "static/media/eCom-el-coin.60ca67b5.svg";